import {
  UserGetWrongRoundSummaryRequest,
  UserGetWrongRoundSummaryResponse,
} from '../../../types/user'
import { useApiPostQuery } from '../useApi'

export const useUserGetWrongRoundSummary = (
  requestData: UserGetWrongRoundSummaryRequest,
  enabled: boolean
) => {
  return useApiPostQuery<UserGetWrongRoundSummaryResponse>(
    '/user/getWrongRoundSummary',
    ['wrongRoundSummary', requestData],
    requestData,
    enabled && !!requestData.USER_ID
  )
}
